<template>
    <Layout :ready="ready" :breadcrumb="breadcrumbItems">

        <slot name="prepend" />

        <template v-if="ready">
            <Filters :value="filtersValue" :criterias="criterias" @input="handleFilterChanged" />

            <template v-if="courses && courses.length > 0">
                <div class="row row-cols-sm-2 row-cols-md-3 row-cols-lg-4 gx-3 gy-4">
                    <template v-for="course in courses">
                        <div class="col" style="min-width: 200px">
                            <CourseItem :course="course">
                                <template v-slot:tag>
                                    <CourseTag :course="course" action />
                                </template>
                            </CourseItem>
                        </div>
                    </template>
                </div>

                <template v-if="pagination.last_page > 1">
                    <div class="mt-4">
                        <b-pagination
                            class="cursus-pagination justify-content-center"
                            :value="currentPage"
                            :total-rows="pagination.total"
                            :per-page="pagination.per_page"
                            prev-text="<"
                            next-text=">"
                            hide-goto-end-buttons
                            @change="handlePageChanged"
                        />
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="border border-primary bg-primary text-uppercase font-weight-bold" style="border-width: 8px!important;">
                    <div class="row justify-content-center gx-0">
                        <div class="col-lg-6">
                            <div class="bg-white py-4 px-4 text-primary">
                                Aucune proposition ne correspond<br class="d-none d-sm-inline"> à ces critères de recherche...
                            </div>
                        </div>
                        <div class="col-auto col-lg-6">
                            <div class="position-relative py-4 px-4 pl-lg-5">
                                <router-link :to="{ query: null }" v-slot="{ href, navigate }">
                                    <a class="text-white stretched-link" :href="href" @click="navigate">
                                        Revenir sur toute la programmation<br>
                                        Formations / Rencontres / Parcours<span  class="text-nowrap">&nbsp;<Icon class="ml-2" name="arrow-right" width=".875rem" height=".875rem" />
                                        </span>
                                    </a>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <Footer :items="footerItems" />
        </template>
        <template v-else>
            <slot />
        </template>
    </Layout>
</template>

<script>
import {getCourses, getCriterias} from "../../api";
import Layout from "../Layout.vue";
import CourseItem from "../CourseItem.vue";
import Filters from "./course-list/Filters.vue";
import {listBreadcrumb} from "../../util/breadcrumb";
import {BPagination} from 'bootstrap-vue';
import {updateDocumentTitle} from "../../util/title";
import CourseTag from "../ui/CourseTag.vue";
import Footer from "../ui/Footer.vue";
import Icon from "../ui/Icon.vue";

export default {
        components: {
            Icon,
            Footer,
            CourseTag,
            Filters,
            Layout,
            CourseItem,
            BPagination,
        },
        props: {
            category: [Number, String],
            perPage: Number,
            showBreadcrumb: Boolean,
            breadcrumb: Array,
            footerItems: Array,
        },
        data() {
            return {
                ready: false,
                courses: null,
                criterias: null,
                pagination: null,
            }
        },
        watch: {
            '$route': 'init',
        },
        computed: {
            breadcrumbItems() {
                return this.showBreadcrumb
                    ? [...this.breadcrumb, ...listBreadcrumb()]
                    : null;
            },
            filtersValue() {
                return { ...this.$route.query }
            },
            currentPage() {
                return this.$route.query.page || 1;
            },
        },
        methods: {
            handlePageChanged(page) {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        page
                    }
                });
            },
            handleFilterChanged(value) {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        ...value,
                        page: 1,
                    }
                })
                .catch(e => console.log(e));
            },
            async init() {
                const { page, year, category, formations } = this.$route.query;

                const response = await getCourses({
                    category,
                    per_page: this.perPage,
                    page,
                    year,
                    formations
                });
                this.courses = response.data;
                this.pagination = response.meta;
            }
        },
        async created() {
            this.criterias = await getCriterias();
            if(this.category && !this.$route.query.category) {
                await this.$router.replace({
                    query: {
                        ...this.$route.query,
                        category: this.category,
                    }
                })
            }
            await this.init();
            updateDocumentTitle(this.breadcrumbItems);
            this.ready = true;
        },
    }
</script>
